import { TYPES } from "store/types";

type WorkSearch = {
  template_SK: string;
  search_state: any;
};

const initialWorkSearch: WorkSearch = {
  template_SK: "",
  search_state: undefined,
};

export const workSearchReducer = (
  state = initialWorkSearch,
  { payload, type }: any,
) => {
  switch (type) {
    case TYPES.SET_TEMPLATE_SK: {
      return { ...state, template_SK: payload.template_SK };
    }
    case TYPES.SET_WORK_SEARCH_FILTER: {
      return { ...state, search_state: payload.search_state };
    }
    case TYPES.CLEAR_WORK_SEARCH: {
      return { ...initialWorkSearch };
    }
    default:
      return state;
  }
};
